<template>
  <div>
    <!-- Contenu Principal -->
    <div class="main-container">
      <!-- Bouton hamburger toujours visible sur mobile -->
      <button :class="['sidebar-toggle', 'd-lg-none', { 'toggle-active': sidebarOpen }]" @click="toggleSidebar">
        <span v-if="!sidebarOpen">☰</span>
        <span v-else>✕</span>
      </button>

      <div class="row content" ref="wrapper">
        <!-- Sidebar -->
        <div :class="['sidebar', { 'sidebar-open': sidebarOpen }]">
          <div class="sidebar-content">
            <div class="sidebar-item">
              <div>
                <button type="button" class="custom-button" data-bs-toggle="modal" data-bs-target="#modalImport">
                  <h5>Import d'une Image</h5>
                </button>
              </div>
            </div>
            <div class="sidebar-item">
              <div>
                <button type="button" class="custom-button" data-bs-toggle="modal" data-bs-target="#modalNew">
                  <h5>Nouveau Pixel Art</h5>
                </button>
              </div>
            </div>
            <div class="sidebar-item">
              <div>
                <router-link class="nav-link active custom-button" to="/concepteur">
                  <h5>Favoris</h5>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- Overlay pour fermer le sidebar sur mobile -->
        <div v-if="sidebarOpen" class="sidebar-overlay d-lg-none" @click="closeSidebar"></div>

        <!-- Contenu principal -->
        <div class="main-content">
          <h2 class="page-title">Liste des Pixel Arts</h2>
          <div class="mosaics-grid">
            <div
              v-for="mosaic in mosaics"
              :key="mosaic.id"
              class="mosaic-card-wrapper"
            >
              <div class="card mosaic-card">
                <router-link class="nav-link active" :to="'/carde/' + mosaic.id">
                  <img :src="mosaic.image" class="card-img-top pixel-art" loading="lazy" alt="Mosaic">
                </router-link>
                <div class="card-body">
                  <h5 class="card-title">{{ mosaic.name }}</h5>
                  <p class="card-text">
                    {{ mosaic.creationDate }} - {{ mosaic.visibility ? 'publique' : 'privé' }}
                  </p>
                  
                  <div class="btn-group" role="group">
                    <div class="btn-group" role="group">
                      <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        Actions
                      </button>
                      <ul class="dropdown-menu">
                        <li>
                          <button class="dropdown-item" @click="openEditor(mosaic.id)">
                            Modifier
                          </button>
                        </li>
                        <li>
                          <button 
                            class="dropdown-item" 
                            :disabled="deletingIds.includes(mosaic.id)" 
                            @click="deleteMosaic(mosaic.id)"
                          >
                            <span v-if="deletingIds.includes(mosaic.id)" class="spinner-border spinner-border-sm" role="status"></span>
                            <span v-else>Supprimer</span>
                          </button>
                        </li>
                        <li v-if="mosaic.pdfGenerated">
                          <button class="dropdown-item" @click="downloadPDF(mosaic.id)">
                            Télécharger PDF
                          </button>
                        </li>
                        <li>
                          <button class="dropdown-item" @click="openPdfProgressStream(mosaic.id)">
                            {{ mosaic.pdfGenerated ? 'Mise à jour PDF' : 'Créer PDF' }}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Import Image -->
    <div class="modal fade" id="modalImport" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalImportLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="modalImportLabel">Import d'une Image</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="addMosaicImg">
              <div class="mb-3">
                <label for="name" class="form-label">Nom :</label>
                <input type="text" id="name" class="form-control" v-model="mosaicName" required>
              </div>
              <div class="mb-3">
                <label for="content" class="form-label">Contenu :</label>
                <textarea id="content" class="form-control" v-model="mosaicContent" rows="3" required></textarea>
              </div>
              <div class="mb-3 form-check">
                <input type="checkbox" id="visibility1" v-model="mosaicVisibility" class="form-check-input">
                <label for="visibility1" class="form-check-label">Rendre publique (visible par tous)</label>
              </div>
              <div class="mb-3">
                <label for="fichier" class="form-label">Choisissez un fichier :</label>
                <input type="file" id="fichier" class="form-control" ref="fileInput" accept="image/*" @change="handleImageUpload" />
              </div>
              <div class="mb-3">
                <label for="width1" class="form-label">Largeur : {{ mosaicWidth }}</label>
                <input type="range" id="width1" class="form-range" v-model.number="mosaicWidth" @input="updateHeightFromWidth" min="8" max="128" step="1">
              </div>
              <div class="mb-3">
                <label for="height1" class="form-label">Hauteur : {{ mosaicHeight }}</label>
                <input type="range" id="height1" class="form-range" v-model.number="mosaicHeight" @input="updateWidthFromHeight" min="8" max="128" step="1">
              </div>
              <button type="submit" class="btn btn-primary w-100">Ajouter</button>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Nouveau Pixel Art -->
    <div class="modal fade" id="modalNew" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalNewLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="modalNewLabel">Nouveau Pixel Art</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="addMosaicNoImg">
              <div class="mb-3">
                <label for="name2" class="form-label">Nom :</label>
                <input type="text" id="name2" class="form-control" v-model="mosaicName" required>
              </div>
              <div class="mb-3">
                <label for="content2" class="form-label">Contenu :</label>
                <textarea id="content2" class="form-control" v-model="mosaicContent" rows="3" required></textarea>
              </div>
              <div class="mb-3 form-check">
                <input type="checkbox" id="visibility2" v-model="mosaicVisibility" class="form-check-input">
                <label for="visibility2" class="form-check-label">Rendre publique (visible par tous)</label>
              </div>
              <div class="mb-3">
                <label for="width2" class="form-label">Largeur : {{ mosaicWidth }}</label>
                <input type="range" id="width2" class="form-range" v-model.number="mosaicWidth" min="8" max="128" step="1">
              </div>
              <div class="mb-3">
                <label for="height2" class="form-label">Hauteur : {{ mosaicHeight }}</label>
                <input type="range" id="height2" class="form-range" v-model.number="mosaicHeight" min="8" max="128" step="1">
              </div>
              <button type="submit" class="btn btn-primary w-100">Créer</button>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Progression -->
    <div class="modal" id="modalProgress" data-bs-backdrop="static" ref="progressModal" data-bs-keyboard="false" tabindex="-1" aria-labelledby="modalProgressLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="modalProgressLabel">Génération en cours</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="progress" role="progressbar">
              <div class="progress-bar" :style="{ width: progressValue + '%' }">{{ progressValue }}%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import * as bootstrap from 'bootstrap';

export default {
  name: 'MosaicManager',
  data() {
    return {
      mosaicName: '',
      mosaicContent: '',
      mosaicVisibility: false,
      mosaicWidth: 32,
      mosaicHeight: 32,
      aspectRatio: 1,
      mosaics: [],
      deletingIds: [],
      pdfMosaic: [],
      progressPercent: 0,
      progressValue: 0,
      sidebarOpen: false,
      es: null,
      modalInstance: null,
      navbarObserver: null,
      navbarCheckInterval: null
    };
  },
  created() {
    this.fetchMosaics();
  },
  mounted() {
    window.onload = () => {
      this.updateNavbarHeight();
    };
    window.addEventListener('resize', this.updateNavbarHeight);
    const modalElement = this.$refs.progressModal;
    this.modalInstance = new bootstrap.Modal(modalElement);

    // Observer les changements de hauteur de la navbar
    this.setupNavbarObserver();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateNavbarHeight);
    if (this.modalInstance) {
      this.modalInstance.dispose();
    }
    if (this.es) {
      this.es.close();
    }
    if (this.navbarObserver) {
      this.navbarObserver.disconnect();
    }
    if (this.navbarCheckInterval) {
      clearInterval(this.navbarCheckInterval);
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    },
    closeSidebar() {
      this.sidebarOpen = false;
    },
    openPdfProgressStream(id) {
      if (this.es) { 
        this.es.close(); 
        this.es = null; 
      }
    
      const jwt = localStorage.getItem('token');
      if (!jwt) {
        console.error('❌ Pas de token JWT');
        alert('Vous devez être connecté');
        return;
      }
    
      const API_URL = process.env.VUE_APP_API_URL || 'https://brickfirst.fr';
      const url = `${API_URL}/api/creatMosaicPDF/${id}/stream?bearer=${encodeURIComponent(jwt)}`;
    
      this.progressValue = 0;
      this.openProgressBar();
    
      try {
        this.es = new EventSource(url);
      
        this.es.addEventListener('started', (e) => {
          const data = JSON.parse(e.data || '{}');
          this.progressValue = typeof data.percent === 'number' ? data.percent : 0;
        });
      
        this.es.addEventListener('progress', (e) => {
          const data = JSON.parse(e.data || '{}');
          if (typeof data.percent === 'number') {
            this.progressValue = data.percent;
          }
        });
      
        this.es.addEventListener('done', () => {
          this.progressValue = 100;
          this.es?.close();
          this.closeProgressBar();
          this.fetchMosaics();
          this.es = null;
        });
      
        this.es.addEventListener('error', (e) => {
          console.error('❌ SSE error:', e);
          if (e.data) {
            const data = JSON.parse(e.data);
            alert('Erreur: ' + data.message);
          }
          this.closeProgressBar();
          this.es?.close();
          this.es = null;
        });
      
        this.es.onerror = (e) => {
          console.error('❌ EventSource error:', e);
          if (this.es && this.es.readyState === EventSource.CLOSED) {
            alert('Erreur de connexion');
            this.es.close();
            this.closeProgressBar();
            this.es = null;
          }
        };
      
      } catch (err) {
        console.error('❌ Erreur EventSource:', err);
        alert('Impossible de se connecter: ' + err.message);
        this.closeProgressBar();
      }
    },
    openEditor(mosaicId) {
      const modals = document.querySelectorAll('.modal.show');
      modals.forEach(modal => {
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();
      });
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());
      
      this.$router.push({
        name: 'MosaicConcepteur',
        query: { mosaicId: mosaicId }
      });
    },
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const img = new Image();
      img.onload = () => {
        this.aspectRatio = img.width / img.height;
        const baseSize = 32;
        if (this.aspectRatio > 1) {
          this.mosaicWidth = Math.round(baseSize * this.aspectRatio);
          this.mosaicHeight = baseSize;
        } else {
          this.mosaicHeight = Math.round(baseSize / this.aspectRatio);
          this.mosaicWidth = baseSize;
        }
      };
      img.src = URL.createObjectURL(file);
    },
    updateHeightFromWidth() {
      if (this.aspectRatio > 0) {
        this.mosaicHeight = Math.round(this.mosaicWidth / this.aspectRatio);
      }
    },
    updateWidthFromHeight() {
      if (this.aspectRatio > 0) {
        this.mosaicWidth = Math.round(this.mosaicHeight * this.aspectRatio);
      }
    },
    async addMosaicImg() {
      try {
        const token = localStorage.getItem('token');
        const formData = new FormData();
        formData.append('name', this.mosaicName);
        formData.append('content', this.mosaicContent);
        formData.append('visibility', this.mosaicVisibility);
        formData.append('fichier', this.$refs.fileInput.files[0]);
        formData.append('width', this.mosaicWidth);
        formData.append('height', this.mosaicHeight);
        const API_URL = process.env.VUE_APP_API_URL || 'https://brickfirst.fr';
        await axios.post(`${API_URL}/api/mosaicsImg`, formData, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });

        this.resetForm();
        this.fetchMosaics();
        bootstrap.Modal.getInstance(document.getElementById('modalImport')).hide();
      } catch (error) {
        console.error("Erreur:", error);
        alert("Erreur lors de l'ajout");
      }
    },
    async addMosaicNoImg() {
      try {
        const token = localStorage.getItem('token');
        const formData = new FormData();
        formData.append('name', this.mosaicName);
        formData.append('content', this.mosaicContent);
        formData.append('visibility', this.mosaicVisibility);
        formData.append('width', this.mosaicWidth);
        formData.append('height', this.mosaicHeight);
        const API_URL = process.env.VUE_APP_API_URL || 'https://brickfirst.fr';
        const response = await axios.post(`${API_URL}/api/mosaicsNoImg`, formData, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        let idMosaic = response.data.idMosaic;
        this.resetForm();
        bootstrap.Modal.getInstance(document.getElementById('modalNew')).hide();
        this.openEditor(idMosaic);
      } catch (error) {
        console.error("Erreur:", error);
        alert("Erreur lors de la création");
      }
    },
    async fetchMosaics() {
      try {
        const token = localStorage.getItem('token');
        const API_URL = process.env.VUE_APP_API_URL || 'https://brickfirst.fr';
        const response = await axios.get(`${API_URL}/api/mosaics/liste`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        this.mosaics = response.data;
      } catch (error) {
        console.error('Erreur:', error);
      }
    },
    async deleteMosaic(id) {
      if (!confirm('Êtes-vous sûr de vouloir supprimer cette mosaïque ?')) return;
      
      try {
        this.deletingIds.push(id);
        const token = localStorage.getItem('token');
        const API_URL = process.env.VUE_APP_API_URL || 'https://brickfirst.fr';
        await axios.delete(`${API_URL}/api/mosaic/suprime/${id}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        this.fetchMosaics();
      } catch (error) {
        console.error('Erreur:', error);
        alert('Erreur lors de la suppression');
      } finally {
        this.deletingIds = this.deletingIds.filter(item => item !== id);
      }
    },
    updateNavbarHeight() {
      const navbar = document.querySelector('.navbar');
      if (navbar) {
        const navbarHeight = navbar.offsetHeight;
        document.documentElement.style.setProperty('--hauteurNavbar', `${navbarHeight}px`);
      }
    },
    openProgressBar() {
      this.modalInstance.show();
    },
    closeProgressBar() {
      this.modalInstance.hide();
    },
    async downloadPDF(idMosaic) {
      try {
        const token = localStorage.getItem('token');
        const API_URL = process.env.VUE_APP_API_URL || 'https://brickfirst.fr';
        const response = await fetch(`${API_URL}/api/pdf/mosaic/${idMosaic}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        if (!response.ok) throw new Error('Erreur téléchargement');
        
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `mosaic-${idMosaic}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Erreur:', error);
        alert('Impossible de télécharger le PDF');
      }
    },
    resetForm() {
      this.mosaicName = '';
      this.mosaicContent = '';
      this.mosaicVisibility = false;
      this.mosaicWidth = 32;
      this.mosaicHeight = 32;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    }
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

body {
  overflow-x: hidden;
  margin: 0;
}

.main-container {
  width: 100%;
  min-height: calc(100vh - var(--hauteurNavbar, 0px));
}

.content {
  display: flex;
  min-height: calc(100vh - var(--hauteurNavbar, 0px));
  width: 100%;
  margin: 0;
  position: relative;
}

/* Sidebar Desktop */
.sidebar {
  background-color: #4dc9ff;
  width: 250px;
  min-width: 250px;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  transition: transform 0.3s ease;
}

.sidebar-content {
  padding: 40px 20px 20px;
}

.sidebar-item {
  padding: 15px 0;
}

.sidebar-toggle {
  display: none;
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1050;
  background-color: #4dc9ff;
  color: white;
  border: none;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  font-size: 1.5rem;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0,0,0,0.3);
  transition: all 0.3s ease;
  align-items: center;
  justify-content: center;
}

.sidebar-toggle:active {
  transform: scale(0.95);
}

.sidebar-toggle:hover {
  background-color: #3ab8e8;
  box-shadow: 0 6px 20px rgba(0,0,0,0.4);
}

.sidebar-toggle span {
  line-height: 1;
}

.sidebar-toggle.toggle-active {
  left: 300px;
  background-color: #ff4d4d;
}

/* Main Content */
.main-content {
  flex: 1;
  padding: 20px 30px;
  overflow-y: auto;
  max-height: calc(100vh - var(--hauteurNavbar, 0px));
}

.page-title {
  margin-bottom: 20px;
  font-size: 1.75rem;
}

.mosaics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.mosaic-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s, box-shadow 0.2s;
}

.mosaic-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0,0,0,0.1);
}

.mosaic-card .card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.mosaic-card .btn-group {
  margin-top: auto;
}

/* Buttons */
.custom-button {
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid white;
  padding: 15px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  text-decoration: none;
  display: block;
}

.custom-button:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

.custom-button h5 {
  color: white;
  margin: 0;
  font-size: 1rem;
  text-align: left;
}

/* Pixel Art */
img.pixel-art {
  image-rendering: pixelated;
  image-rendering: crisp-edges;
  width: 100%;
  height: 250px;
  object-fit: contain;
  background-color: #f8f9fa;
}

/* Dropdown menu */
.dropdown-menu {
  min-width: 200px;
}

.dropdown-item {
  padding: 10px 20px;
  cursor: pointer;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

.dropdown-item:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Progress bar */
.progress {
  height: 25px;
}

.progress-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

/* RESPONSIVE - TABLET */
@media (max-width: 992px) {
  .sidebar {
    width: 200px;
    min-width: 200px;
  }

  .main-content {
    padding: 15px 20px;
  }

  .mosaics-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 15px;
  }

  .page-title {
    font-size: 1.5rem;
  }
}

/* RESPONSIVE - MOBILE */
@media (max-width: 768px) {
  .content {
    flex-direction: column;
  }

  /* Sidebar Mobile */
  .sidebar {
    position: fixed;
    top: var(--hauteurNavbar, 0px);
    left: 0;
    width: 280px;
    height: calc(100vh - var(--hauteurNavbar, 0px));
    z-index: 1040;
    transform: translateX(-100%);
    box-shadow: 2px 0 10px rgba(0,0,0,0.2);
  }

  .sidebar-open {
    transform: translateX(0);
  }

  .sidebar-toggle {
    display: flex !important;
  }

  .sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1030;
  }

  .sidebar-content {
    padding: 20px 15px;
  }

  /* Main Content Mobile */
  .main-content {
    width: 100%;
    padding: 70px 15px 15px;
    max-height: none;
  }

  .page-title {
    font-size: 1.25rem;
    margin-bottom: 15px;
  }

  .mosaics-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  img.pixel-art {
    height: 200px;
  }

  /* Cards Mobile */
  .mosaic-card {
    margin-bottom: 0;
  }

  .card-title {
    font-size: 1.1rem;
  }

  .card-text {
    font-size: 0.9rem;
  }

  /* Buttons Mobile */
  .btn-primary {
    padding: 8px 16px;
    font-size: 0.9rem;
  }

  .custom-button h5 {
    font-size: 0.95rem;
  }

  /* Modal Mobile */
  .modal-dialog {
    margin: 10px;
    max-width: calc(100% - 20px);
  }

  .modal-body {
    padding: 15px;
  }

  .form-label {
    font-size: 0.9rem;
  }

  .form-control,
  .form-range {
    font-size: 1rem;
  }
}

/* RESPONSIVE - SMALL MOBILE */
@media (max-width: 480px) {
  .sidebar {
    width: 100%;
  }

  .sidebar-toggle {
    width: 55px;
    height: 55px;
    font-size: 1.4rem;
    bottom: 15px;
    left: 15px;
  }

  .sidebar-toggle.toggle-active {
    left: calc(100% - 70px);
  }

  .main-content {
    padding: 60px 10px 10px;
  }

  .page-title {
    font-size: 1.1rem;
  }

  img.pixel-art {
    height: 180px;
  }

  .card-body {
    padding: 12px;
  }

  .dropdown-menu {
    min-width: 180px;
    font-size: 0.9rem;
  }
}

/* Spinner */
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  margin-right: 5px;
  vertical-align: middle;
}
</style>